import { useCallback, useMemo } from "react";
import { RangeValue } from "@evergis/ui";

import { getSafetyScale, scaleIsDefault } from "../../../../evergis/core/scale";
import { usePropAsState } from "../../../../hooks/usePropAsState";
import { useDefaultScaleRange } from "../../../../hooks/style/useDefaultScaleRange";
import { LayerInfo } from "../../../../interfaces/resourceInfo";

interface LayerMinMaxScale {
  scale: RangeValue;
  setScale: (v: RangeValue) => void;
  resetScale: VoidFunction;
}

export const useLayerMinMaxScale = (layer: LayerInfo): LayerMinMaxScale => {
  const defaultScaleRange = useDefaultScaleRange();

  const initialScale = useMemo(
    () =>
      scaleIsDefault(layer.style, defaultScaleRange)
        ? defaultScaleRange
        : getSafetyScale(layer.style, defaultScaleRange),
    [layer.style, defaultScaleRange],
  );

  const [scale, setScale] = usePropAsState(initialScale);

  const resetScale = useCallback(() => setScale(defaultScaleRange), [defaultScaleRange, setScale]);

  return { scale, setScale, resetScale };
};
